export enum EmergencyErrorCode {
  EXPIRED = -3400,
}
